import { equal, length } from "./javascript";
import { firstLetterToUppercase, emailValidation, number, passwordValidation, otpCodeValidation, urlValidation } from "./regex";

export const allValidations = (name, value, state, ignore = []) => {
    const formErrors = { ...state.formErrors };
    if (ignore.includes(name)) {
        if (formErrors[name]) formErrors[name] = "";
        return formErrors;
    }
    switch (name) {
        case "email":
            if (equal(length(value))) {
                formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
            } else if (!emailValidation(value)) {
                formErrors[name] = `Please enter valid email!`;
            } else {
                formErrors[name] = "";
            }
            break;

        case "loginPassword":
            if (equal(length(value))) {
                formErrors[name] = `Password is required!`;
            } else {
                formErrors[name] = "";
            }
            break;

        case "password":
        case "newPassword":
            if (equal(length(value))) {
                formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
            } else if (!passwordValidation(value)) {
                formErrors[
                    name
                ] = `Please enter a password with 8-16 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character`;
            } else {
                formErrors[name] = "";
            }
            break;
        case "fullName":
        case "name":
        case "serviceName":
        case "service":
        case "title":
        case "subTitle":
        case "description":
        case "benefitsTitle":
        case "secondaryImageTitle":
        case "question":
        case "answer":
        case "role":
        case "paragraph":
            if (equal(length(value))) {
                formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
            } else {
                formErrors[name] = "";
            }
            break;

        case "serviceDescription":
            if (equal(length(value))) {
                formErrors[name] = `Sub heading is required!`;
            } else {
                formErrors[name] = "";
            }
            break;
        case "otpcode":
            if (equal(length(value))) {
                formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
            } else if (!otpCodeValidation(value)) {
                formErrors[name] = `Enter Valid OTP!`;
            } else {
                formErrors[name] = "";
            }
            break;
        case "image":
        case "iconImage":
        case "beforeImage":
        case "afterImage":
        case "singleImage":
        case "primaryBeforeImage":
        case "primaryAfterImage":
        case "secondaryBeforeImage":
        case "secondaryAfterImage":
        case "primarySingleImage":
        case "secondarySingleImage":
            if (!value.length) {
                formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
            } else {
                formErrors[name] = "";
            }
            break;
        case "url":
            if (equal(length(value))) {
                formErrors[name] = `${firstLetterToUppercase(name)} is required!`;
            } else if (!urlValidation(value)) {
                formErrors[name] = `Please enter valid url!`;
            } else {
                formErrors[name] = "";
            }
            break;
        default:
            break;
    }

    return formErrors;
};
